<script setup lang="ts">
import { WrenchScrewdriverIcon } from '@heroicons/vue/24/outline'
import { highlight } from '@/utils/highlight'
import type { OsServiceResult } from '@/api/omnisearchApi'

defineProps<{
  item: OsServiceResult
  query: string
}>()
</script>

<template>
  <div class="flex items-start gap-3 px-3 py-2.5 rounded-lg text-left">
    <span class="mt-0.5 flex-shrink-0 w-8 h-8 rounded-md bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
      <WrenchScrewdriverIcon class="w-4 h-4 text-orange-600 dark:text-orange-400" />
    </span>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium truncate text-base-content" v-html="highlight(item.name ?? '—', query)" />
      <div class="flex flex-wrap gap-x-3 gap-y-0.5 mt-0.5">
        <span v-if="item.externalReference" class="text-xs text-base-content/60">
          Réf : <span v-html="highlight(item.externalReference, query)" />
        </span>
        <span v-if="item.type" class="text-xs text-base-content/50">{{ item.type }}</span>
      </div>
    </div>
    <span class="badge badge-ghost badge-xs self-center flex-shrink-0">pas de lien</span>
  </div>
</template>
